/**
 * Each stop on the map. Replace placeholder text/photos with your real content!
 *
 * Puzzle types:
 *   "rank"        - Drag items into the correct order
 *   "multiple"    - Multiple choice question
 *   "unscramble"  - Unscramble a word/phrase
 *   "maze"        - Click the correct path through a mini maze
 *   "spot"        - Click the correct item(s) from a set
 *   "fillin"      - Type the correct answer
 *   "blocks"      - Arrange falling blocks (tetris-lite)
 *   "memory"      - Flip-card memory match
 */

// Big Bear photos (8 total - 4 per strip)
import bigBear1 from '../assets/Big-Bear/IMG_3263.JPG';
import bigBear2 from '../assets/Big-Bear/R1-04670-020A.JPG';
import bigBear3 from '../assets/Big-Bear/IMG_7642.jpg';
import bigBear4 from '../assets/Big-Bear/IMG_7776.jpg';
import bigBear5 from '../assets/Big-Bear/IMG_0908.JPG';
import bigBear6 from '../assets/Big-Bear/IMG_5757.jpg';
import bigBear7 from '../assets/Big-Bear/IMG_5758.jpg';
import bigBear8 from '../assets/Big-Bear/DSC09807.JPG';

// Cabo photos (8 total - 4 per strip)
import cabo1 from '../assets/Cabo/IMG_6908.JPG';
import cabo2 from '../assets/Cabo/clai332-152.jpg';
import cabo3 from '../assets/Cabo/clai332-163.jpg';
import cabo4 from '../assets/Cabo/IMG_1122.JPG';
import cabo5 from '../assets/Cabo/IMG_5768.jpg';
import cabo6 from '../assets/Cabo/IMG_6038.jpg';
import cabo7 from '../assets/Cabo/IMG_6988.jpg';
import cabo8 from '../assets/Cabo/IMG_6995.jpg';

// Hawaii-Hike photos (8 total - 4 per strip)
import hawaii1 from '../assets/Hawaii-Hike/E2166AE2-08C7-4000-A00B-ED91D8A73649.JPG';
import hawaii2 from '../assets/Hawaii-Hike/IMG_4380.jpg';
import hawaii3 from '../assets/Hawaii-Hike/IMG_4673.jpg';
import hawaii4 from '../assets/Hawaii-Hike/IMG_4892.jpg';
import hawaii5 from '../assets/Hawaii-Hike/IMG_5004.jpg';
import hawaii6 from '../assets/Hawaii-Hike/IMG_5133.jpg';
import hawaii7 from '../assets/Hawaii-Hike/IMG_5315.jpg';
import hawaii8 from '../assets/Hawaii-Hike/IMG_6902.jpg';

// Laguna-Beach photos (8 total - 4 per strip)
import laguna1 from '../assets/Laguna-Beach/DSC01758.JPG';
import laguna2 from '../assets/Laguna-Beach/DSC01789.JPG';
import laguna3 from '../assets/Laguna-Beach/IMG_3954.jpg';
import laguna4 from '../assets/Laguna-Beach/IMG_3974.jpg';
import laguna5 from '../assets/Laguna-Beach/IMG_3981.JPG';
import laguna6 from '../assets/Laguna-Beach/IMG_4019.jpg';
import laguna7 from '../assets/Laguna-Beach/IMG_4070.jpg';
import laguna8 from '../assets/Laguna-Beach/IMG_4174.jpg';

// Nemi-USC photos (8 total - 4 per strip)
import nemi1 from '../assets/Nemi-USC/IMG_2289.jpeg';
import nemi2 from '../assets/Nemi-USC/IMG_4621.jpeg';
import nemi3 from '../assets/Nemi-USC/IMG_6185.jpeg';
import nemi4 from '../assets/Nemi-USC/IMG_6187.jpeg';
import nemi5 from '../assets/Nemi-USC/IMG_7585.jpeg';
import nemi6 from '../assets/Nemi-USC/IMG_7664.jpeg';
import nemi7 from '../assets/Nemi-USC/IMG_7719.jpeg';
import nemi8 from '../assets/Nemi-USC/sami380-043.jpeg';

export const STOPS = [
  {
    id: 'big-bear',
    name: 'Big Bear',
    // Position on the map (percent from top-left)
    x: 78,
    y: 8,
    clue: '❄️ Find the snowy mountain where we ranked every meal...',
    icon: '🏔️',
    puzzleType: 'rank',
    puzzleData: {
      prompt: 'Rank our Big Bear meals from BEST to worst!',
      items: ['Poke', 'Indian Food', 'Pizza', 'Burgers', 'Fajitas'],
      // SET THIS to YOUR correct ranking (index 0 = best)
      correctOrder: ['Poke', 'Indian Food', 'Burgers', 'Fajitas', 'Pizza'],
    },
    reward: {
      type: 'photo', // 'photo' | 'text' | 'both'
      message: 'Our snowy getaway — nothing beats our trips bundling up together!! Especially with warm cookies <3',
      photos: [bigBear1, bigBear2, bigBear3, bigBear4, bigBear5, bigBear6, bigBear7, bigBear8],
    },
  },
  {
    id: 'bhavnani-house',
    name: 'The Bhavnani House',
    x: 28,
    y: 28,
    clue: '🏠 Find the house where movie nights became our thing...',
    icon: '🏡',
    puzzleType: 'story',
    puzzleData: {
      segments: [
        {
          type: 'text',
          content: 'One day, early on when we first started dating, we were at your house for a cozy movie night. ',
        },
        {
          type: 'text',
          content: 'We set up in your theater room — popcorn, snacks, blankets, the whole thing. ',
        },
        {
          type: 'text',
          content: 'We picked out one of your girlfriend\'s all-time favorites to watch together... ',
        },
        {
          type: 'dropdown',
          options: ['Fast and Furious', 'Tangled', 'Good Will Hunting', 'How I Met Your Mother', 'Loki'],
          answer: 'Tangled',
        },
        {
          type: 'text',
          content: '! We were so excited, all bundled up and ready. ',
        },
        {
          type: 'text',
          content: 'But of course, your family kept popping in to say hello and see us together. ',
        },
        {
          type: 'text',
          content: 'They were joking around and messing with you the whole time... and honestly it was the ',
        },
        {
          type: 'dropdown',
          options: ['best', 'sweetest', 'cutest', 'funniest', 'most perfect'],
          allCorrect: true, // Any answer works!
        },
        {
          type: 'text',
          content: '. That house holds so many of our moments — movie nights, baking brownies, ',
        },
        {
          type: 'dropdown',
          options: ['pickleball', 'basketball', 'spikeball', 'soccer', 'parties'],
          answer: 'pickleball',
        },
        {
          type: 'text',
          content: ' in the backyard, cookouts with everyone. ',
        },
        {
          type: 'text',
          content: 'It\'s where so much of us started. 💛',
        },
      ],
    },
    reward: {
      type: 'text',
      message: 'Brownies, pickleball, movies, cookouts, games — and getting to know your family — such remarkable memories together, I love you! 💛',
    },
  },
  {
    id: 'hawaii-hike',
    name: 'Hawaii Hike',
    x: 90,
    y: 42,
    clue: '🌺 Find the hidden trail that led to a secret pool...',
    icon: '🌴',
    puzzleType: 'maze',
    puzzleData: {
      prompt: 'Navigate the jungle trail to find the hidden swimming pool!',
      // Simple grid maze: 0=path, 1=wall, 2=start, 3=end
      grid: [
        [2, 0, 1, 1, 1, 1],
        [1, 0, 0, 0, 1, 1],
        [1, 1, 1, 0, 0, 1],
        [1, 0, 0, 0, 1, 1],
        [1, 0, 1, 1, 1, 1],
        [1, 0, 0, 0, 0, 3],
      ],
    },
    reward: {
      type: 'photo',
      message: 'I love traveling and exploring with you!! Hawaii was such a paradise, I loved being there with you! Such delicious food and finding that hidden pools was unforgettable 🌊',
      photos: [hawaii1, hawaii2, hawaii3, hawaii4, hawaii5, hawaii6, hawaii7, hawaii8],
    },
  },
  {
    id: 'farmers-market',
    name: "Brentwood Farmers Market",
    x: 18,
    y: 68,
    clue: '🧺 Find the Sunday morning spot where we always stock up...',
    icon: '🧺',
    puzzleType: 'spot',
    puzzleData: {
      prompt: 'What do we always get at the farmers market together?',
      items: [
        { name: 'Sourdough', emoji: '🍞', correct: true },
        { name: 'Honey', emoji: '🍯', correct: false },
        { name: 'Orange Juice', emoji: '🍊', correct: true },
        { name: 'Pickles', emoji: '🥒', correct: false },
        { name: 'Fresh Flowers', emoji: '💐', correct: true },
        { name: 'Coffee', emoji: '☕', correct: false },
        { name: 'Burritos', emoji: '🌯', correct: false },
        { name: 'Lettuce', emoji: '🥬', correct: false },
        { name: 'Figs', emoji: '🫐', correct: false },
      ],
    },
    reward: {
      type: 'text',
      message: 'Sunday mornings with you are everything 🌻',
    },
  },
  // --- CABO (now spot 5) ---
  {
    id: 'cabo',
    name: 'Cabo San Lucas',
    x: 50,
    y: 38,
    clue: '🌴 Find the beach where we went all-in on vacation mode...',
    icon: '🏝️',
    puzzleType: 'unscramble',
    puzzleData: {
      prompt: 'Unscramble these Cabo memories!',
      words: [
        { scrambled: 'LAL VISULNICE', answer: 'ALL INCLUSIVE' },
        { scrambled: 'OGNAM KCDE', answer: 'MANGO DECK' },
        { scrambled: 'YRTID SYKENOM', answer: 'DIRTY MONKEYS' },
      ],
    },
    reward: {
      type: 'photo',
      title: 'Cabo Wabo Baby!',
      message: 'Spring break in Cabo is a forever memory – I loved our solo time together at the start, enjoying the all inclusive, and spending so much time with you and our friends making amazing memories! I LOVE YOU JAI JAI!! 🌅🍹',
      photos: [cabo1, cabo2, cabo3, cabo4, cabo5, cabo6, cabo7, cabo8],
    },
  },
  {
    id: 'laguna-beach',
    name: 'Laguna Beach',
    x: 70,
    y: 85,
    clue: '🍰 Find our new favorite dessert spot...',
    icon: '🍨',
    puzzleType: 'story',
    puzzleData: {
      segments: [
        {
          type: 'text',
          content: 'Last month, we had such a magical getaway together! Spending so much time together is always the best. ',
        },
        {
          type: 'text',
          content: 'I love driving with you, exploring, discussing (yapping), trying new restaurants, watching the sunset, and all the quiet personal moments in between! ',
        },
        {
          type: 'text',
          content: 'So grateful to have found a new fav dessert place: ',
        },
        {
          type: 'dropdown',
          options: ['Oakobing', 'South by Swell', 'Dukes Hula Pie', 'Sweet Rose Creamery', 'Somi Somi'],
          answer: 'South by Swell',
        },
        {
          type: 'text',
          content: '! Thanks for indulging my love of ',
        },
        {
          type: 'dropdown',
          options: ['Film photobooths', 'Running', 'Hiking', 'Clubbing'],
          answer: 'Film photobooths',
        },
        {
          type: 'text',
          content: ' <3 These adventures together mean the world to me!! As do all the memories we get to make together! Cheers to many more to come!!! \n P.S. I love the pictures we took together!!!!',
        },
      ],
    },
    reward: {
      type: 'photo',
      message: 'Exploring, yapping, sunsets, dessert, and photobooths with you — Laguna was magic! 🌅📸',
      photos: [laguna1, laguna2, laguna3, laguna4, laguna5, laguna6, laguna7, laguna8],
    },
  },
  // --- NEMI / USC (now spot 7) ---
  {
    id: 'nemi-usc',
    name: 'Nemi ;)',
    x: 55,
    y: 62,
    clue: '🎓 Find where college memories and inside jokes live...',
    icon: '🏛️',
    puzzleType: 'trivia',
    puzzleData: {
      questions: [
        {
          prompt: "Who's roommate hung a North Korean flag in the courtyard?",
          options: ["Don't worry about it", "Don't worry about it", "Don't worry about it", "Don't worry about it"],
          allCorrect: true,
        },
        {
          prompt: "What style did Jai draw his picture for the 2124 door to add himself?",
          options: ["Realistic", "Anime", "Stick Figure", "Abstract"],
          correctAnswer: "Stick Figure",
        },
        {
          prompt: "What level of hanging is allowed in a common room?",
          options: ["Working", "Holding hands", "Cuddling", "Kiss on the neck", "Snogging", "Watching movies and yapping every single night together"],
          allCorrect: true,
        },
      ],
    },
    reward: {
      type: 'photo',
      message: 'From patio shenanigans to late night yapping — these memories mean everything to me 🎓💛',
      photos: [nemi1, nemi2, nemi3, nemi4, nemi5, nemi6, nemi7, nemi8],
    },
  },
  // --- THE GRAND MATCHING PUZZLE (spot 8) ---
  {
    id: 'grand-matching',
    name: 'The Grand Matching',
    x: 45,
    y: 75,
    clue: '🗝️ One final puzzle before the treasure reveals itself...',
    icon: '🧩',
    puzzleType: 'matching',
    puzzleData: {
      prompt: 'Match each memory to its place!',
      pairs: [
        { riddle: 'Sweet treats and an even sweeter place to meet', answer: 'Manhattan Beach' },
        { riddle: '"You squeeze my hand three times in the back of the taxi" – Taylor Swift', answer: 'New York' },
        { riddle: 'Best eats, soju, making child chopsticks for Jai using a rubberband and paper', answer: 'Ktown' },
        { riddle: 'Laughing with friends, dancing, dressing up together, dance floor makeouts', answer: 'Tri Delt & Spark' },
        { riddle: 'Enjoyed out, made at home for hours with love', answer: "Jon & Vinny's" },
      ],
    },
    reward: {
      type: 'text',
      message: 'You matched them all! Every place, every memory, every moment with you is my favorite. Hope you had fun down this little trip down memory lane!! I LOVE YOU 💛',
    },
  },
];
